<div class="fullcontainer">
  <div class='sheet'>
    @if (this.isError) {
      <div class="alert alert-danger">Something went wrong. Please try again later.</div>
    }
    @if (this.isSuccess) {
      <div class="alert alert-success">Driver hours was updated successfully</div>
    }
    <div class='titleContainer'>
      <h1 class='header'>Daily Driver Hours for {{ this.currentDate }}</h1>
      <div>
        <button class='btn btn-secondary' routerLink='/drivers'><i class="fas fa-arrow-left"></i> Back</button>&nbsp;
        <button class='btn btn-secondary' routerLink='/drivers/hours/advance'><i class="fas fa-cog"></i> Advanced</button>
      </div>
    </div>

    <div class='searchContainer'>
      <div class='formRow'>
        <div class="form-row">
          <div class="form-group">
            <input [(ngModel)]='this.newDate' type="date" name='name' class="form-control" id="inputEmail4">
          </div>
        </div>
      </div>
      <button class='btn btnSearch btn-small btn-primary' (click)='updateCurrentDate()'>Search</button>
      <button class='btn btnSearch btn-small' (click)='prevDay()'>Previous Day</button>
      <button class='btn btnSearch btn-small' (click)='nextDay()'>Next Day</button>
    </div>
    <p><strong></strong></p>

    <table>
      <thead>
        <th>&nbsp;&nbsp;</th>
        <th style='width:30%'>Start Time</th>
        <th style='width:30%'>End Time</th>
        <th style='width:30%'>Lunch Break</th>
        <th style='width:30%'>Chargable Hours</th>
      </thead>
      <tbody>
        @for (item of this.hours; track item) {
          @if (this.getAbsenceByDriverId(item.driverId) === null) {
            <tr>
              <td class='nameCol'>{{ item.driver.firstName }} {{ item.driver.lastName }} </td>
              <td>
                <div class="form-row">
                  <div class="form-group">
                    <input (keyup)='updateTotalHours(item)' type="time" name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.startTime'>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-row">
                  <div class="form-group">
                    <input (keyup)='updateTotalHours(item)' type="time" name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.endTime'>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-row">
                  <div class="form-group">
                    <input (keyup)='updateTotalHours(item)' type="number" name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.lunchBreak'>
                  </div>
                </div>
              </td>
              <td>
                <div class="form-row">
                  <div class="form-group">
                    <input type="number" name='name' class="form-control" id="inputEmail4" [(ngModel)]='item.chargeableHours'>
                  </div>
                </div>
              </td>
            </tr>
          }
          @if (this.getAbsenceByDriverId(item.driverId) !== null) {
            <tr>
              <td class='nameCol'>{{ item.driver.firstName }} {{ item.driver.lastName }} </td>
              <td colspan='90'>
                <div class='alert alert-warning'>{{ this.getAbsenceByDriverId(item.driverId).driverAbsenceType.name }} - <strong>{{ this.getAbsenceByDriverId(item.driverId).notes }}</strong></div>
              </td>
            </tr>
          }
        }
      </tbody>
    </table>
    <br />

    <button type="submit" class="btn btn-success" (click)='this.onSaveClicked()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/drivers'>Cancel</button>
  </div>
</div>
